import {useState} from "react";
import FlashResultsTotalScore from "./FlashResultsTotalScore";
import {isNullOrUndefined} from "../../../../services/Validator";
import {useResizeListener} from "../../../../listeners/SystemResizeListener";
import ResultsScoreEmojiImage from "../../../images/flashScreens/resultsStepScreen/ResultsScoreEmojiImage";
import SystemResultsAppreciationDialog from "../../../dialogs/SystemResultsAppreciationDialog";

export default function FlashResultsScore({correctAnswers, total}) {
    // Used in ResultsScreen component to display
    // flash score

    // PROPERTIES
    const [isAppreciationModalOpen, setIsAppreciationModalOpen] = useState(false)
    let successRatio = (isNullOrUndefined(correctAnswers) || isNullOrUndefined(total)) ? null : Math.round(100*correctAnswers/total)

    // HOOKS
    // ---- Eventually close modal during screen resize
    useResizeListener(() => setIsAppreciationModalOpen(false))

    // BUILD
    if (isNullOrUndefined(successRatio))
        return null;
    return (
        <div className="w-[112px] min-w-[112px] h-full flex flex-col items-center">
            {/** MODAL */}
            <SystemResultsAppreciationDialog open={isAppreciationModalOpen}
                                             handleClose={() => setIsAppreciationModalOpen(false)}
                                             successRatio={successRatio} />
            {/** CORE */}
            <FlashResultsTotalScore correctAnswers={correctAnswers}
                                    total={total} />
            <ResultsScoreEmojiImage successRatio={successRatio}
                                    openAppreciation={() => setIsAppreciationModalOpen(true)} />
        </div>
    );
}